const phrases = {
	userExpired: 'Váš přístup do Portálu byl ukončen. Kontaktujte nás na adrese portal@intergram.cz',
	setBankIdentityUserConfirmation: 'Opravdu napojit bankovní identitu na uživatele $userName?\n\n$userInfo\n\nBude odeslán notifikační email na $emails.',
	onlyIntergramAndRaventiaUsersCanBeAdmins: 'Pouze uživatelé z Intergramu a Raventie mohou být administrátory',
	and: 'a',
	'submissionRole.PER': 'Výkonní umělci',
	'submissionRole.PRO': 'Výrobci',
	matchUser: 'Napojit uživatele',
	userNameMatch: 'Shoda uživatelského jména',
	candidates: 'Kandidáti',
	loginAsUser: 'Přihlásit se jako uživatel',
	createUser: 'Vytvořit uživatele',
	newUser: 'Nový uživatel',
	userNameMustNotContainSpaces: 'Uživatelské jméno nesmí obsahovat mezery',
	createAndMatch: 'Vytvořit a napojit',
	profileIsLinkedToBankIdentity: 'Uživatel je propojen s bankovní identitou.',
	profileWasLinkedToBankIdentity: 'Uživatel byl (ale už není) propojen s bankovní identitou.',
	'unmatchedBankIdLoginMessage.line1': 'Autorizace se nezdařila.',
	'unmatchedBankIdLoginMessage.line2': 'Pokud máte jméno a heslo, přihlašte se níže. Tím dojde k propojení s Vaší bankovní identitou, přes kterou se budete moci příště přihlásit.',
	'unmatchedBankIdLoginMessage.line3': 'Případně vyčkejte na manuální ověření pracovníky INTERGRAM. Následně Vás budeme kontaktovat.',

	'unmatchedBankIdLoginMessage.userExpired': 'Uživatelský účet spojený s touto identitou je uzamčen. Vyčkejte, prosím, na autorizaci pracovníkem INTERGRAM, budete kontaktováni.',
	'unmatchedBankIdLoginMessage.generalError': 'Při přihlašování došlo k chybě.',

	includingDeleted: 'Včetně smazaných',
	termsOfService: 'Obecné podmínky',

	loginWithUserNameAndPassword: 'Přihlášení uživatelským jménem a heslem',
	loginWithBankId: 'Přihlásit se přes Bank iD',
	bankIdLoginBlockText: 'Nově můžete použít Bank iD, po kliknutí na odkaz stačí vybrat svou banku a přihlásit se stejně jako do svého internetového bankovnictví.',
	reallyDeleteBankIdentity: 'Opravdu smazat bankovní identitu?',
	unmatched: 'Nenapojené',
	matched: 'Napojené',
	deleted: 'Smazané',
	bankIdentities: 'Bankovní identity',
	removeBankIdentity: 'Odstranit bankovní identitu',
	reallyRemoveBankIdentity: 'Opravdu odstranit bankovní identitu?\n\nPo odstranění nebude možné se přes ni přihlašovat k tomuto uživatelskému účtu.',
	noBankIdentityConnectedToThisUserAccount: 'Váš uživatelský účet není propojen s žádnou bankovní identitou.\n\nPokud se chcete připojovat bankovní identitou, zvolte při přístím přihlášení možnost "Přihlášení přes BankID".',

	aboutPortal: 'O klientském portále',
	refresh: 'Aktualizovat',
	invalidPassword: 'Neplatné heslo',
	profile: 'Profil',
	rightHolderReward: 'Odměna držitele práv',
	'submissionTransition.NEW2SAVED_FOR_LATER': 'Vytvořeno a uloženo na později',
	'submissionTransition.NEW2SUBMITTED': 'Vytvořeno a odesláno ke zpracování',
	'submissionTransition.SUBMITTED': 'Odesláno ke zpracování',
	'submissionTransition.SUBMITTED2IN_PROGRESS': 'Zaměstnanec Intergramu přijal podání a pracuje na jeho zpracování',
	submissionStatusChange: 'Změna stavu podání',
	changeHistory: 'Historie změn',
	SubmissionAdmin: 'Správa podání',
	more: 'více',
	fileSubmission: 'Odeslat podání',
	setSubmissionStateTo: 'Nastavit stav na',
	attachANoteOrAFile: 'Připojte poznámku nebo přílohu',
	uploadingFileProgress: 'Nahrávám soubor $fileName..$progress%',
	selectAttachment: 'Vybrat přílohu',
	fileSizeSumLimitExceeded: 'Soubor(y) nelze nahrát, byla by překročena maximální velikost příloh ($limit)',
	or: 'nebo',
	attachmentDragText: 'Přetáhněte sem soubor(y)',
	maxSize: 'max. velikost',
	list: 'Seznam',
	saveForLater: 'Uložit na později',
	Dashboard: 'Přehled',
	UsageReport: 'Užití a odměny',
	MyRecordings: 'Moje nahrávky',
	Submissions: 'Podání',
	Notifications: 'Notifikace',
	SystemSettings: 'Systémová nastavení',
	SessionLog: 'Log přihlášení',
	NotificationAdmin: 'Správa notifikací',
	UserProfile: 'Uživatelský profil',
	SystemMaintenance: 'Odstávky systému',
	UserAdmin: 'Správa uživatelů',
	BankId: 'Bankovní identity',
	AuthenticationCode: 'Autorizační kódy',
	Submission: 'Podání',
	newSubmission: 'Nové podání',
	troubleChangingPasswordOrSigningIn: 'Máte potíže se změnou hesla či přihlášením?',
	'dashboard.subHeader.broadcaster': 'Vysílatel',
	'dashboard.subHeader.channel': 'Stanice',
	'dashboard.subHeader.audioVideo': 'Audio / Video',
	sendErrorMessage: 'Chyba odesílání',
	'authenticationErrorCode.-20056': 'Uživatel zadal neplatný kód',
	'authenticationErrorCode.-20057': 'Platnost kódu vypršela',
	forgottenPassword: 'Zapomněli jste heslo?',
	passwordChange: 'Změna hesla',
	passwordReset: 'Vytvoření nového hesla',
	passwordHasBeenChanged: 'Vaše heslo bylo změněno',
	passwordResetEmailSent: 'Na *$email* jsme odeslali odkaz pro změnu hesla.',

	userActivated: 'Uživatel byl aktivován $when',
	userActivationSent: 'Aktivační e-mail byl odeslán $when',
	passwordsDoNotMatch: 'Hesla se neshodují',
	createYourPortalPassword: 'Vytvořte si své heslo pro přihlášení do portálu.',
	passwordMustMeetTheseCriteria: 'Heslo musí splňovat',
	'pwd.min8Chars': 'minimální délka 8 znaků',
	'pwd.upperLower': 'minimálně jedno velké a jedno malé písmeno',
	'pwd.specialChars': 'minimálně jedno číslo či speciální znak',
	'pwd.passwordVerification': 'heslo a jeho ověření se shodují',
	'pwd.newPasswordVerification': 'nové heslo a jeho ověření se shodují',
	submit: 'Odeslat',
	nowYouCanLogIn: 'Nyní se můžete přihlásit!',
	activationSuccessful: 'Aktivace přístupu k portálu dokončena!',
	passwordCreation: 'Vytvoření hesla',
	back: 'Zpět',
	invalidSmsCode: 'Zadali jste neplatný SMS kód',
	invalidUserName: 'Neplatné uživatelské jméno',
	smsCodeExpired: 'Platnost SMS kódu vypršela',
	invalidActivationCode: 'Neplatný aktivační kód',
	activationCodeExpired: 'Platnost aktivačního kódu vypršela',
	smsNotReceived: 'Nepřišla vám SMS?',
	enterSmsCode: 'Zadejte prosím SMS kód pro přihlášení, který jsme odeslali na Váš *mobilní telefon* ($phone).',
	passwordResetHint: 'Vyplňte prosím Vaše uživatelské jméno. Na Váš *email* zašleme odkaz, jehož pomocí heslo změníte.',
	invalidCredentials: 'Neplatné přístupové údaje',
	smsAuthentication: 'SMS ověření',
	errorSendingLoginCodeSms: 'Při odesílání SMS s kódem pro přihlášení došlo k chybě.',
	welcomeHeader: 'Vítejte na klientském portále',
	contractNeededForAccess: 'Pro přístup do klientského portálu je třeba mít uzavřenou smlouvu s Intergramem.',
	iHaveAContract: 'Mám smlouvu',
	iDontHaveAContract: 'Nemám smlouvu',
	needAdvice: 'Potřebujete poradit?',
	loginNoun: 'Přihlášení',
	login: 'Přihlásit se',
	iAmARegisteredUser: 'Mám přístupové údaje do klientského portálu.',
	newContract: 'Uzavření smlouvy s Intergramem',
	iWantAContract: 'Nemám uzavřenou smlouvu a mám zájem využívat klientský portál Intergramu.',
	sendActivationLink: 'Poslat aktivační link',
	yes: 'Ano',
	no: 'Ne',
	activationLinkSent: 'Aktivační link byl úspěšně odeslán',
	reallySendActivationLink: 'Opravdu poslat aktivační link?',
	duplicateUserName: 'Uživatel s tímto uživatelským jménem už existuje',
	terminate: 'Ukončit',
	reactivate: 'Obnovit',
	'new.user': 'Nový uživatel',
	'usageReportFlag_P.short': 'P',
	usageReportFlag_P: 'Prodej',
	'usageReportFlag_R.short': 'R',
	usageReportFlag_R: 'Repríza',
	inDetail: 'Detailně',
	aggregatedItems: 'Agregované položky',
	'usageReport.time_used_sum.subText': 'stopáže',
	'usageReport.spins_sum.subText': 'užití',
	'usageReport.ip_gross_amount_sum.subText': 'Kč (Brutto)',
	'usageReport.np_gross_amount_sum.subText': 'Kč (Brutto)',
	backToOverview: 'Zpět na seznam',
	cancelChanges: 'Zrušit změny',
	maintenanceNotification: 'Dne *$day* dojde k odstávce systému v čase *$timeFrom* - *$timeTo* z důvodu jeho aktualizace. Před jejím započtením bude vaše práce uložena.',
	performerSignIn: 'Web umělců',
	producerSignIn: 'Web výrobců',
	youNeedToSignIn: 'Pro vstup na portál se musíte přihlásit nebo registrovat.',
	stayLoggedIn: 'Zůstat přihlášen',
	sessionLogoutInLessThan: 'Budete odhlášeni za méně než',
	'minutes.1': 'minutu',
	'minutes.2': 'minuty',
	'minutes.3': 'minuty',
	'minutes.4': 'minuty',
	'minutes.x': 'minut',
	doYouWantToSaveOpenSubmission: 'Chcete uložit rozpracované podání?',
	saveAndClose: 'Uložit a zavřít',
	doCancelSubmission: 'Ano, zrušit podání',
	reallyCancelSubmission: 'Opravdu chcete zrušit podání?',
	cancelSubmission: 'Zrušit podání',
	close: 'Zavřít',
	closeWithoutSaving: 'Zavřít bez uložení',
	youHaveMadeSubmissionChanges: 'Provedli jste v otevřeném podání změny, chcete je před zavřením uložit?',
	anotherModifiedSubmission: 'Máte otevřené jiné rozpracované podání, chcete jej uložit a otevřít nové?',
	youHaveBeenLoggedOut: 'Byli jste odhlášeni',
	dashboardNoDataMessage: 'Nemáte k dispozici žádné odměny.',
	usageReportNoDataMessage: 'Nemáte žádná užití.',
	myRecordingsNoDataMessage: 'Nemáte žádné nahrávky.',
	saveAndOpenNew: 'Uložit a otevřít nové',
	openWithoutSaving: 'Otevřít nové bez uložení',
	rowCount: 'Počet záznamů',
	next: 'Další',
	previous: 'Předchozí',
	processingRequest: 'Zpracovávám požadavek..',
	czk: 'Kč',
	delete: 'Smazat',
	help: 'Nápověda',
	showAltNames: 'zobrazit alternativní jména',
	altNames: 'Alternativní jména',
	'submissionStatusGroup.OPEN': 'Rozpracovaná podání',
	'submissionStatusGroup.SUBMITTED': 'Odeslaná podání',
	'submissionStatusGroup.CLOSED': 'Uzavřená podání',
	hide: 'skrýt',
	logout: 'Odhlásit se',
	noItemsFound: 'Nenalezeny žádné položky',
	save: 'Uložit',
	ok: 'OK',
	personalInfo: 'Osobní údaje',
	roleList: 'Seznam rolí',
	cancel: 'Storno',
	displayedRecordings: 'Zobrazené nahrávky',
	displayedSubmissions: 'Zobrazená podání',
	submissionCount: 'Počet podání',
	recordingCount: 'Počet nahrávek',
	pageNumber: 'Přejít na stránku',
	rowsPerPage: 'Záznamů na stránku',
	exportSelectionToCSV: 'Exportovat výběr do CSV',
	'childRoleRelType.MEM': 'Člen skupiny',
	'childRoleRelType.ADM': 'Společný zástupce skupiny',
	'footer.socialNetworks': 'Zůstaňte s námi v kontaktu na sociálních sítích',
	'recordingTypeA': 'Zvuk',
	'recordingTypeV': 'Video',
	'distType.IP': 'IP (Identifikovatelný)',
	'distType.NP': 'NP (Neidentifikovatelný)',
	'audioVideo.A': 'Zvuk',
	'audioVideo.V': 'Video',
	'recordingSource.isrcProtocol': 'Z nahrávacích protokolů',
	'recordingSource.other': 'Z ostatních zdrojů',
	readingItems: 'Načítám položky',
	mandatoryField: 'Povinné pole',
	maintenanceToMustBeGreaterThanMaintenanceFrom: 'Konec odstávky musí být po jejím začátku',
	notificationFromDateMustBeLessThanMaintenanceFrom: 'Notifikace od musí před začátkem odstávky',
	maintenanceFromAndToMustBeSameDay: 'Začátek a konec odstávky musí být ve stejný den',
	toDateMustBeGreaterThanFromDate: 'Konec notifikace musí být po jejím začátku',
	'new.systemMaintenance': 'Nová odstávka systému',
	'new.notification': 'Nová notifikace',
	'ynBoolean.Y': 'Ano',
	'ynBoolean.N': 'Ne',
	'validationMessageHeader': 'Opravte prosím nejdříve chyby:',
	'validationIgnorableErrors': 'Formulář obsahuje chyby, které nebrání uložení:',
	'validationIgnorableErrors2': 'Formulář obsahuje i chyby, které nebrání uložení:',
	'validationWarnings': 'Upozornění',

	saveAnyway: 'Přesto uložit',
	backToForm: 'Zpět na formulář',
	isAMandatoryField: ' je povinné pole',

};

const columnTexts = {
	notification_channel: 'Kanál',
	text: 'Text',
	maintenanceFrom: 'Začátek',
	maintenanceTo: 'Konec',
	from_date: 'Od',
	to_date: 'Do',
	logoutWarningThreshold: 'Jak dlouho před odhlášením zobrazit upozornění (minuty)',
	sessionDurationInMinutes: 'Délka sessiony (minuty)',
	account_category: 'Kategorie práv',
	usage_year: 'Rok užití',
	income_type: 'Typ příjmu',
	reward_amount: 'Výše odměny',
	reward_netto: 'K vyplacení',
	'categoryName.dashboard': 'Kategorie práv',
	'effectivePeriodId.dashboard': 'Rok užití',
	'distType.dashboard': 'Typ příjmu',
	'brutto.dashboard': 'Výše odměny',
	'netto.dashboard': 'K vyplacení',
	total_netto_reward: 'Celková odměna k vyplacení',
	highest_reward_category: 'Nejvyšší odměny z kategorie',
	top_channel: 'Nejvyšší odměna na stanici',
	most_profitable_recording: 'Nejvýdělečnější nahrávka',
	person_group: 'Osoba | Skupina',
	role: 'Role',
	distribution_period: 'Distribuční období',

	nameAndSurname: 'Jméno a příjmení',
	session_id: 'Id',
	user: 'Uživatel',
	proxy_user: 'Proxy uživatel',
	login_type: 'Typ přihlášení',
	login_time: 'Čas přihlášení',
	logout_time: 'Čas odhlášení',
	last_access_time: 'Poslední přístup',

	recording: 'Nahrávka',
	production_release_year: 'Rok výroby (vydání)',
	length: 'Stopáž',
	audio_video: 'Zvuk/Video',
	isrc: 'ISRC',

	from: 'Od',
	to: 'Do',

	profile_name: 'Název profilu',
	first_name: 'Jméno',
	last_name: 'Příjmení',
	date_of_birth: 'Datum narození',
	profile_type: 'Typ profilu',
	email: 'E-mail',
	phone: 'Telefon',
	street_and_house_number: 'Ulice a č.p.',
	city: 'Město',
	zip_code: 'PSČ',
	day: 'Den',
	notification_from_date: 'Notifikace od',
	comments: 'Komentář',
	production_year: 'Rok výroby',
	release_year: 'Rok vydání',
	is_isrc_protocol: 'ISRC protokol',
	is_deleted: 'Smazáno',
	is_active: 'Aktivní',
	created_when: 'Vytvořeno',
	edited_when: 'Upraveno',
	maintenance: 'Odstávka',
	station: 'Stanice',
	last_modified: 'Poslední změna',
	usage_date: 'Datum a čas užití',
	recording_type_id: 'Zvuk / Video',
	recording_id: 'Id nahrávky',
	time_used: 'Užitá stopáž',
	spins: 'Počet užití',
	ip_gross_amount: 'Částka IP',
	np_gross_amount: 'Částka NP',
	is_rerun: 'Repríza',
	is_sale: 'Prodej',
	title: 'Titul',
	subtitle: 'Podtitul',
	broadcaster: 'Vysílatel',
	party: 'Osoba',
	parties: 'Osoby',
	'from_date.authenticationCode': 'Platnost od',
	'to_date.authenticationCode': 'Platnost do',
	used_when: 'Použito',
	authentication_code_type: 'Typ kódu',
	authentication_code_status: 'Stav',
	authentication_code: 'Kód',
	sent_to: 'Posláno na',
	'born.short': 'nar.',
	user_name: 'Uživatelské jméno',
	display_name: 'Jméno',
	language: 'Jazyk',
	activated: 'Aktivováno',
	'languageId.form': 'Jazyk',
	smsCode: 'SMS kód',
	password: 'Heslo',
	attachments: 'Přílohy',
	submission_id: 'Id podání',
	password_verification: 'Znovu heslo',
	new_password: 'Nové heslo',
	new_password_verification: 'Ověření nového hesla',
	old_password: 'Stávající heslo',
	'name.submission': 'Vlastní označení',
	'type.submission': 'Předmět podání',
	'role_id.submission': 'Podání za osobu',
	'comments.submission': 'Poznámka',
	'submitted_when.submission': 'Odesláno (vytvořeno)',
	status: 'Stav',
	submitted_by: 'Podal(a)',
	brutto: 'Brutto',
	netto: 'Netto',
	bank_identity_id: 'Id',
	matched_user: 'Napojený uživatel',
	name: 'Jméno',
	birth_date: 'Datum narození',
	phone_number: 'Telefon',
	birth_number: 'Rodné číslo',
	primary_nationality: 'Národnost',
	deleted_when: 'Smazáno',
	userMatchedWhen: 'Uživatel napojen',
	is_system_admin: 'Systémový administrátor',
	is_submission_admin: 'Správce podání',
};

const l10n = {
	phrases,
	columnTexts
};

export default l10n;
